import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-jobs-card',
  templateUrl: 'card.component.html',
  styleUrls: ['./card.component.scss']
})
export class JobsCardComponent {
  @Input() setting: any;
  @Input() item: any;
}
